/*
    Handles width, height, and pixel ratio.
    Informs Experience of resize events
    Assumes full viewport (window.innerWidth, window.innerHeight)
*/
import { EventDispatcher } from "three"

export default class Sizes extends EventDispatcher{
    constructor(){
        super()
        //console.log("Sizes Class")
        // Setup
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)

        // Resize Event
        //this.resizeEvent = new Event("resize")

        window.addEventListener("resize", () =>{
            this.width = window.innerWidth
            this.height = window.innerHeight
            this.pixelRatio = Math.min(window.devicePixelRatio, 2)

            this.dispatchEvent({
                type: 'resize',
                message: 'dispatch resize event'
            })
            //this works
            //this.dispatchEvent(new Event("resize"))
        })
    }
}